<template>
  <div class="row">
    <card-default>
      <div
        slot="title"
        class="card-title">
        <div class="h5">
          Users
        </div>
      </div>
      <div
        slot="body"
        class="row">
        <field-input
          v-model="searchString"
          name="searchString"
          label="Search"
          class="col-sm-2"
          @input="search"
        />
        <field-select2
          v-model="perPage"
          :options="['25', '50']"
          :on-change="perPageChanged"
          name="perPage"
          label="Per page"
          class="col-sm-2"
        />
        <div class="col float-right">
          <auth-link
            to="new"
            append
            class="btn btn-primary btn-micro float-right"
            permission="user-create"
          >
            New user
          </auth-link>
        </div>
      </div>
      <table
        slot="body"
        class="table table-striped first-td-padding">
        <thead>
          <tr>
            <th>
              User
            </th>
            <th>
              Email
            </th>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in filteredList"
            :key="user.id"
          >
            <td>
              {{ user.username }}
            </td>
            <td>
              {{ user.email }}
            </td>
            <td class="text-right">
              <div class="btn-group">
                <auth-link
                  :to="user.id.toString()"
                  append
                  class="btn btn-primary btn-micro"
                  permission="user-view"
                >
                  <span
                    aria-hidden="true"
                    class="fa fa-edit"/>
                </auth-link>
              </div>
            </td>
          </tr>
        </tbody>
        <pagination
          :page-selected="pageSelected"
          :state="$store.state.user"
        />
      </table>
    </card-default>
  </div>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import FieldInput from '@/components/form/FieldInput'
import FieldSelect2 from '@/components/form/FieldSelect2'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'
import Pagination from '@/components/Pagination'

export default {
  name: 'UsersList',
  components: {
    FieldInput,
    FieldSelect2,
    CardDefault,
    Pagination
  },
  data () {
    return {
      searchString: ''
    }
  },
  computed: {
    ...mapGetters('user', [
      'usersArray',
      'currentPage',
      'totalPageCount',
      'perPage'
    ]),
    filteredList () {
      if (!this.searchString) {
        return this.usersArray
      }
      var searchString = this.searchString.toLowerCase()
      return this.usersArray.filter(user => {
        return user.username.toLowerCase().includes(searchString) ||
          user.email.toLowerCase().includes(searchString)
      })
    },
    getParams () {
      const params = {
        'per-page': this.perPage
      }
      if (this.searchString) {
        params.username = this.searchString
        params.email = this.searchString
      }
      return params
    }
  },
  created () {
    this.search()
  },
  methods: {
    ...mapActions('user', [
      'get',
      'remove'
    ]),
    ...mapMutations({
      setPerPage: 'user/SET_PER_PAGE'
    }),
    search: debounce(function () {
      this.get(this.getParams)
    }, 300),
    perPageChanged (value) {
      this.setPerPage(value)
      this.search()
    },
    pageSelected (page) {
      const getParams = this.getParams
      getParams.page = page
      this.get(getParams)
    }
  }
}
</script>
